
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university",
      function () {
        return require("private-next-pages/university/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university"])
      });
    }
  